// This is generated.  Alter it in blockGroups/formElements/types/Slider.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, min, max, required, defaultValue } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // Determine optional/editable flags based on the context (readOnly) and the required flag.
    let optional;
    let editable;
    if (!context?.readOnly) {
      editable = true;
      if (!required) {
        optional = true;
      }
    }

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) =>
      optional ? Type.Optional(schema) : schema;

    // Build the number schema with constraints
    const numberOptions = {
      title: title,
      'x-id': id,
      'x-dataType': 'number',
      'x-propertyName': propertyName,
      'x-optional': !!optional,
      'x-editable': !!editable,
    };

    // Add min/max constraints if provided
    if (min !== undefined && min !== null) {
      numberOptions.minimum = min;
    }
    if (max !== undefined && max !== null) {
      numberOptions.maximum = max;
    }
    if (defaultValue !== undefined && defaultValue !== null) {
      numberOptions.default = defaultValue;
    }

    const sliderSchema = maybeOptional(Type.Number(numberOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: sliderSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType('formElements', 'Slider', module.exports);
